import { Directive, HostBinding, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[narwhaliaDefault]'
})
export class DefaultImageDirective {
  @HostBinding('src')
  @Input()
  src: string;
  @Input() narwhaliaDefault: string;
  @HostListener('error')
  error() {
    this.updateUrl();
  }

  updateUrl() {
    this.src = this.narwhaliaDefault;
  }
}
